import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
:root,
:host {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to right" or "to left" need to be switched to using deg values
 * 3) Background Position From is used for reversing animation from right to left at 0%
 * 4) Background Position To is used for reversing animation from right to left at 100%
 * 5) Rotate Icon to 180deg for nav button
 * 6) Transformation size for badge left positions
 * 7) Transformation size for badge right positions
 * 8 to 18) Padding values for Input Field Type Tel
 */
[dir=rtl] {
  --rtlTranslateX: 50%; /* 1 */
  --rtlGradientToRight: 270deg; /* 2 */
  --rtlBackgroundPositionFrom: -135%; /* 3 */
  --rtlBackgroundPositionTo: 0%; /* 4 */
  --rtlRotate180: 180deg; /* 5 */
  --rtlRotate135: 135deg;
  --rtlBadgeLeft: -1.5; /* 6 */
  --rtlBadgeRight: 1.5; /* 7 */
  --rtlTelTypeInputFieldPaddingStart: calc(var(--size-base-unit) * 5); /* 8 */
  --rtlTelTypeInputFieldPaddingEnd: calc(var(--size-base-unit) * 2); /* 9 */
  --rtlTelTypeInputFieldMedPaddingStart: calc(var(--size-base-unit) * 4.5); /* 10 */
  --rtlTelTypeInputFieldMedPaddingEnd: calc(var(--size-base-unit) * 1.5); /* 11 */
  --rtlTelTypeInputFieldSmPaddingStart: calc(var(--size-base-unit) * 4); /* 12 */
  --rtlTelTypeInputFieldSmPaddingEnd: calc(var(--size-base-unit) * 1); /* 13 */
  --rtlTelTypeInputFieldCharBeforePaddingEnd: calc(var(--size-base-unit) * 3.75); /* 14 */
  --rtlTelTypeInputFieldCharAfterPaddingStart: calc(var(--size-base-unit) * 6); /* 15 */
  --rtlTelTypeInputFieldCharAfterErrPaddingStart: calc(var(--size-base-unit) * 9); /* 16 */
  --rtlTelTypeInputFieldIconAfterErrPaddingStart: calc(var(--size-base-unit) * 8); /* 17 */
  --rtlTelTypeInputFieldIconCharAfterErrPaddingStart: calc(var(--size-base-unit) * 12); /* 18 */
  --rtlDisplayNone: none;
  --rtlDisplayBlock: block;
  --rtlDrawerRightTranslateX: -100%;
  --rtlDrawerLeftTranslateX: 100%;
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/**
 * style for text ellipsis
 */
/**
 * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
 */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */ /* ------------------------------------*\
    #TABLE-OBJECT
\*------------------------------------ */
/**
 * Table object host (cat-table-object)
 */
:host {
  display: contents;
}

/**
 * Table object
 */
.cat-c-table-object {
  width: var(--cat-table-min-width, 100%);
}
.cat-c-table-object.cat-c-table-cell-size-sm {
  --cat-c-table-cell--min-height: calc(var(--size-base-unit) * 4);
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 1);
}
.cat-c-table-object.cat-c-table-cell-size-md {
  --cat-c-table-cell--min-height: calc(var(--size-base-unit) * 5);
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 1.5);
}
.cat-c-table-object.cat-is-even-order-stripe {
  --cat-c-table-body-even-background-pass-down: var(--cat-theme-color-background-subtle);
}
.cat-c-table-object.cat-is-odd-order-stripe {
  --cat-c-table-body-odd-background-pass-down: var(--cat-theme-color-background-subtle);
}

/**
 * Table object body
 * 1) Position relative to position overflow gradients
 */
.cat-c-table-object__body {
  position: relative; /* 1 */
  /**
   * Table object body within table object overflow left
   */
  /**
   * Table object body within table object overflow right
   */
}
.cat-is-overflow-left .cat-c-table-object__body {
  /**
   * Left overflow gradient for the table object body
   */
}
.cat-is-overflow-left .cat-c-table-object__body:before {
  content: "";
  display: block;
  position: absolute;
  background: linear-gradient(var(--rtlGradientToRight, 90deg), var(--cat-theme-color-background-default), rgba(255, 255, 255, 0.001) 30%);
  height: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
  width: calc(var(--size-base-unit) * 6);
  z-index: var(--cat-z-index-100);
  pointer-events: none;
}
.cat-is-overflow-right .cat-c-table-object__body {
  /**
   * Right overflow gradient for the table object body
   */
}
.cat-is-overflow-right .cat-c-table-object__body:after {
  content: "";
  display: block;
  position: absolute;
  background: linear-gradient(var(--rtlGradientToRight, 90deg), rgba(255, 255, 255, 0.001) 30%, var(--cat-theme-color-background-default));
  height: 100%;
  inset-block-start: 0;
  inset-inline-end: 0;
  width: calc(var(--size-base-unit) * 6);
  z-index: var(--cat-z-index-100);
  pointer-events: none;
}

/**
 * Table object body inner
 * 1) Actual container within the table object body that scrolls
 * 2) Fixed height required for position sticky to work on child elements
 */
.cat-c-table-object__body-inner {
  overflow: auto; /* 1 */
  width: 100%;
  height: 100%;
  max-height: var(--cat-table-height, 400px); /* 2 */
}
.cat-c-table-object__body-inner::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}
.cat-c-table-object__body-inner::-webkit-scrollbar-track {
  border-radius: 12px;
  background: var(--cat-theme-color-background-subtle);
  margin-inline-start: var(--cat-table-scrollbar-margin-left);
  margin-block-start: var(--cat-table-scrollbar-margin-top);
}
.cat-c-table-object__body-inner::-webkit-scrollbar-thumb {
  background: var(--cat-theme-color-background-subtle-hover);
  border-radius: 12px;
}

/**
 * Table object header
 * 1) The containers the appear above the table object body
 * 2) Aligns the content into a row
 */
.cat-c-table-object__header {
  width: 100%;
  /**
   * Align slotted items in a row.
   */
}
.cat-c-table-object__header slot {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/**
 * Table object header
 * 1) The container that appears above the table object body
 */
.cat-c-table-object__header {
  margin-block-end: calc(var(--size-base-unit) * 1);
}

/**
 * Table object footer
 * 1) The container that appears below the table object body
 */
.cat-c-table-object__footer {
  margin-block-start: calc(var(--size-base-unit) * 1);
}

/**
 * Table object tooltip
 * 1) The tooltip that appears over table header cells if they are greater than two lines
 * 2) Tooltip is positioned absolutely to the object body
 */
.cat-c-table-object__tooltip {
  height: 0;
  width: 0;
  position: absolute;
  z-index: var(--cat-z-index-top);
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
}

/**
 * Table bulk actions
 * 1) The flyout container for the bulk actions that appears above the first table cell header
 */
.cat-c-table-object__bulk-action {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: fit-content;
  position: absolute;
  inset-block-start: calc(calc(var(--size-base-unit) * 4.75) * -1);
  inset-inline-start: 0;
  color: var(--cat-theme-color-content-strong);
  background-color: var(--cat-theme-color-background-brand);
  padding-inline: calc(var(--size-base-unit) * 1.5) calc(var(--size-base-unit) * 0.5);
  z-index: var(--cat-z-index-300);
  margin-block-end: calc(var(--size-base-unit) * 0.5);
  opacity: 0;
  visibility: hidden;
  /**
   * The indication arrow at the bottom of the flyout
   */
}
.cat-c-table-object__bulk-action:before {
  content: "";
  display: block;
  width: calc(var(--size-base-unit) * 1);
  height: calc(var(--size-base-unit) * 1);
  transform: rotate(45deg);
  background-color: var(--cat-theme-color-background-brand);
  position: absolute;
  inset-inline-start: calc(var(--size-base-unit) * 3);
  inset-block-end: calc(calc(var(--size-base-unit) * 0.5) * -1);
}
.cat-is-bulk-action-active .cat-c-table-object__bulk-action {
  opacity: 1;
  visibility: visible;
}

/**
 * Table bulk actions title
 * 1) The title to the bulk action container that displays before the actions
 */
.cat-c-table-object__bulk-action-title {
  font-weight: normal;
  margin-inline-end: calc(var(--size-base-unit) * 1);
  white-space: nowrap;
}

/**
 * Table bulk actions buttons
 * 1) The slotted container that holds all the action buttons
 */
.cat-c-table-object__bulk-action-buttons {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

/**
 * Table bulk actions buttons slotted
 * 1) Styling for all the slotted item in the bulk actions buttons wrapper
 * 2) Styling for the contextual menu trigger for more bulk action items
 */
.cat-c-table-object__bulk-action-buttons slot[name=bulkAction]::slotted(*),
.cat-c-table-object__bulk-action-buttons slot[name=bulkActionSingle]::slotted(*),
.cat-c-table-object__bulk-action-more-trigger {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  background: transparent;
  outline: 0;
  border: 0;
  margin: 0;
  text-decoration: none;
  padding: calc(var(--size-base-unit) * 0.75) calc(var(--size-base-unit) * 1);
  transition: all 0.15s ease;
  color: var(--cat-theme-color-content-strong);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

/**
 * Table bulk actions buttons slotted hover, focus, active
 * 1) Hover, focus, and active states for slotted items and contextual menu trigger
 */
.cat-c-table-object__bulk-action-buttons slot[name=bulkAction]::slotted(*:hover),
.cat-c-table-object__bulk-action-buttons slot[name=bulkAction]::slotted(*:focus),
.cat-c-table-object__bulk-action-buttons slot[name=bulkAction]::slotted(*:active),
.cat-c-table-object__bulk-action-buttons slot[name=bulkActionSingle]::slotted(*:hover),
.cat-c-table-object__bulk-action-buttons slot[name=bulkActionSingle]::slotted(*:focus),
.cat-c-table-object__bulk-action-buttons slot[name=bulkActionSingle]::slotted(*:active),
.cat-c-table-object__bulk-action-more-trigger:hover,
.cat-c-table-object__bulk-action-more-trigger:focus,
.cat-c-table-object__bulk-action-more-trigger:active {
  color: var(--cat-theme-color-content-strong-hover);
}

/**
 * Table bulk actions buttons slotted focus-visible
 * 1) Focus visible state for slotted items.
 */
.cat-c-table-object__bulk-action-buttons slot[name=bulkAction]::slotted(*:focus-visible),
.cat-c-table-object__bulk-action-buttons slot[name=bulkActionSingle]::slotted(*:focus-visible),
.cat-c-table-object__bulk-action-more-trigger:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, -2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}

/**
 * Table bulk actions more trigger icon
 * 1) The arrow down icon that appears next to the more trigger in the bulk actions
 */
.cat-c-table-object__bulk-action-more-trigger-icon {
  --cat-icon-width: calc(var(--size-base-unit) * 1);
  --cat-icon-height: calc(var(--size-base-unit) * 1);
  margin-inline-start: calc(var(--size-base-unit) * 0.5);
}

/**
 * Table modal for mobile list view
 */
.cat-c-modal__body {
  display: flex;
  flex-direction: column;
  gap: calc(var(--size-base-unit) * 2);
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
}
`;
       